import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const payInvoice = ({ invoiceId, paymentMethod, amount }) => {
  return mutateApi({
    url: `/account/invoice_payment/${invoiceId}/pay`,
    method: "POST",
    data: {
      payment_method_id: paymentMethod,
      amount,
    },
  })
}

export const getInvoice = ({ invoiceId }) => {
  return queryApi(`/account/invoice_payment/${invoiceId}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}
